<template>
  <form>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('period')"
            :placeholder="$t('period')"
            url="/student/period/catalog"
            name_field="name"
            value_field="period_id"
            @selected="set_period"
            ref="period_dropdown"
            :is_multiple="false"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("names") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.first_name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("surname") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.surname" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("id card number") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.id_card_number" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("birthdate") }}</label>
          <input type="date" class="input" v-model="meta.birthdate" />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('program')"
            :placeholder="$t('select program')"
            url="/student/program/catalog"
            name_field="name"
            value_field="program_id"
            @selected="set_program"
            ref="program_dropdown"
            :is_multiple="false"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('stage')"
            :placeholder="$t('stage')"
            url="/student/stage/catalog"
            name_field="name"
            value_field="stage_id"
            @selected="set_stage"
            ref="stage_dropdown"
            :is_multiple="false"
            :extra_data="{ program_id: meta.program_id }"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("email") }}</label>
          <div class="control">
            <input class="input" type="email" v-model="meta.email" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("phone") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.phone" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("address") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.address" />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "New",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.first_name ||
        !v.meta.surname ||
        !v.meta.id_card_number ||
        !v.meta.program_id ||
        !v.meta.stage_id ||
        !v.meta.period_id
      );
    },
  },
  methods: {
    set_initial_state() {
      let v = this;
      v.meta = {
        first_name: "",
        surname: "",
        id_card_number: "",
        birthdate: "",
        settings: {},
      };
      v.error = "";
      v.$refs.program_dropdown.clear();
      v.$refs.stage_dropdown.clear();
      v.$refs.period_dropdown.clear();
      // v.uuid = "";
    },
    set_program(program) {
      let v = this;
      if (program) v.meta.program_id = program.program_id;
    },
    set_stage(stage) {
      let v = this;
      if (stage) v.meta.stage_id = stage.stage_id;
    },
    get_data() {
      let v = this;
      return v.meta;
    },
    set_period(period) {
      let v = this;
      if (period) v.meta.period_id = period.period_id;
    },
  },
  mounted() {},
  watch: {
    is_form_invalid(value) {
      let v = this;
      v.$emit("form-valid", !value);
    },
  },
};
</script>
<style></style>
